/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow

import type { Element } from 'react';

import React from 'react';
import { Col, Form, FormGroup } from 'reactstrap';
import {
  CITY,
  COUNTRY,
  MODEL_NAME,
  PROJECT_NAME,
  STATE,
  STREET,
  ZIP,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { Field } from '#components/pages/Models/Model/support/form/index.js';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import SiteLocationLockNote from '#components/pages/Models/Model/sections/support/SiteLocationLockNote/index.jsx';
import ProjectSelector from './ProjectSelector/index.js';
import Sp3AiLegend from './Sp3AiLegend/index.js';

type Props = {|
  fieldsByName: Object,
  heading: string,
  isReadOnly?: boolean,
  onNext: Function,
|};

const ModelAndSiteInfoSection = ({
  fieldsByName,
  heading,
  isReadOnly = false,
  onNext,
}: Props): Element<'div'> => (
  <div>
    <h2>{heading}</h2>
    {fieldsByName[MODEL_NAME] && <Sp3AiLegend form={fieldsByName[MODEL_NAME].form} />}
    <Form noValidate>
      <FormGroup tag="fieldset">
        <legend>General Information</legend>
        {fieldsByName[PROJECT_NAME] && <ProjectSelector field={fieldsByName[PROJECT_NAME]} />}
        <FormGroup row>
          <Col lg="9">
            <Field field={fieldsByName[MODEL_NAME]} />
          </Col>
        </FormGroup>
      </FormGroup>
      <FormGroup tag="fieldset">
        <legend>
          Site Address <Tip tipId="siteAddress" />
        </legend>
        <FormGroup row>
          <Col lg="4">
            <Field field={fieldsByName[COUNTRY]} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="4">
            <Field field={fieldsByName[STREET]} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="4">
            <Field field={fieldsByName[CITY]} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="4">
            <Field field={fieldsByName[STATE]} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col lg="4">
            <Field field={fieldsByName[ZIP]} />
          </Col>
        </FormGroup>
        <SiteLocationLockNote isReadOnly={isReadOnly} />
      </FormGroup>
      <NextButton onClick={onNext} />
    </Form>
  </div>
);

export default ModelAndSiteInfoSection;
